import { Plus, Workflow } from 'lucide-react';
import { Card } from '@/components/ui/Card';
import { Table } from '@/components/ui/Table';
import { ButtonLink } from '@/components/ui/Button';
import { useStrategies } from '@/api/queries';
import { strategyBuilderPath } from '@/lib/navigation';

export default function StrategiesPage() {
  const { data: strategies, isLoading, error } = useStrategies();

  const headers = ['Name', 'ID', 'Nodes', 'Connections', 'Updated', 'Actions'];

  if (isLoading) {
    return (
      <div>
        <h1 style={{ marginBottom: 'var(--space-lg)' }}>Strategies</h1>
        <Card>
          <p style={{ fontFamily: 'var(--font-mono)', fontSize: '0.78rem' }}>Loading...</p>
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1 style={{ marginBottom: 'var(--space-lg)' }}>Strategies</h1>
        <Card>
          <p style={{ color: 'var(--accent-conditions)', fontFamily: 'var(--font-mono)', fontSize: '0.78rem' }}>
            {error.message}
          </p>
        </Card>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-lg">
        <h1 className="m-0">Strategies</h1>
        <ButtonLink to={strategyBuilderPath()} variant="primary">
          <Plus size={16} /> New strategy
        </ButtonLink>
      </div>
      <Card>
        <Table headers={headers}>
          {strategies?.map((s) => (
            <tr key={s.id}>
              <td style={{ fontFamily: 'var(--font-display)', fontWeight: 600 }}>{s.name}</td>
              <td style={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', color: 'var(--text-secondary)' }}>{s.id}</td>
              <td>{s.nodeCount}</td>
              <td>{s.connectionCount}</td>
              <td style={{ fontFamily: 'var(--font-mono)', fontSize: '0.75rem' }}>{new Date(s.updatedUtc).toLocaleDateString()}</td>
              <td>
                <ButtonLink
                  to={strategyBuilderPath(s.id)}
                  variant="outline-info"
                >
                  <Workflow size={14} /> Open editor
                </ButtonLink>
              </td>
            </tr>
          ))}
        </Table>
      </Card>
    </div>
  );
}
